import { api } from "../../services/api";

export async function fetchClientes({ paginaAtual, itensPorPagina }) {
  const token = localStorage.getItem("@medusapayments:access_token");

  try {
    const response = await api.get("/client", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      params: {
        page: paginaAtual,
        limit: itensPorPagina
      }
    });

    const data = response.data;

    return {
      data: data.data || [], // mudar 'dados' para 'data'
      total: data.total || 0,
      page: data.page || 1,
      pages: data.pages || 1
    };
  } catch (error) {
    throw error?.response?.data || error;
  }
}
